import axios from 'axios';
import { CURRENT_DEPLOYMENT_VERSION } from '@/services/deploymentVersion';

// A new instance per shell keeps integration credentials out of the shop client.
export function createIntegrationClient({ onExpired = () => {} } = {}) {
  let token = null;
  const apiBase = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000';
  const client = axios.create({
    baseURL: apiBase,
    timeout: 15000,
    withCredentials: false,
  });
  client.interceptors.request.use(config => {
    if (!/^\/(?:sessions|session|catalog(?:\/price-lookup|\/articles\/[1-9]\d*\/images)?|project(?:\/positions(?:\/[1-9]\d*)?)?)$/.test(config.url || '')) {
      throw new Error('Unzulässiger Integrationsendpunkt.');
    }
    const starting = config.url === '/sessions';
    if (!starting && !token) throw new Error('Keine Integrationssession vorhanden.');
    config.headers = config.headers || {};
    // Explicitly overwrite even inherited Axios defaults.
    config.headers.Authorization = starting ? undefined : 'Bearer ' + token;
    config.headers['Content-Type'] = 'application/json';
    config.headers.Accept = 'application/json';
    config.headers['X-Frontend-Version'] = CURRENT_DEPLOYMENT_VERSION;
    config.baseURL = apiBase;
    config.url = '/api/external/v1' + config.url;
    config.withCredentials = false;
    config.auth = undefined;
    config.xsrfCookieName = null;
    return config;
  });
  client.interceptors.response.use(response => response, error => {
    if (error?.response?.status === 401 && token) {
      token = null;
      onExpired();
    }
    return Promise.reject(error);
  });
  return {
    get: (...args) => client.get(...args),
    post: (...args) => client.post(...args),
    put: (...args) => client.put(...args),
    delete: (...args) => client.delete(...args),
    setToken(value) {
      if (!/^[a-f0-9]{64}$/.test(value || '')) throw new Error('Ungültiger IntegrationSession-Bearer.');
      token = value;
    },
    clearToken() { token = null; },
    resolveAssetUrl(value) {
      if (typeof value !== 'string' || !value.startsWith('/storage/beschlaege/')
          || value.includes('..') || value.includes('\\') || value.includes('?') || value.includes('#')) {
        throw new Error('Ungültige Produktbildreferenz.');
      }
      return new URL(value, apiBase).href;
    },
  };
}
